/* eslint-disable */
import { doc, runTransaction } from "firebase/firestore";
import { db } from "../firebase";

export const consumeSubscriptionToken = async ({ accountId }) => {
  if (!accountId) {
    throw new Error("Missing accountId");
  }

  const accountRef = doc(db, "account", accountId);

  const normalizePlanName = (planName) =>
    String(planName || "")
      .trim()
      .replace(/[أإآ]/g, "ا")
      .toLowerCase();

  return runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(accountRef);

    if (!snapshot.exists()) {
      throw new Error("Account not found");
    }

    const accountData = snapshot.data();
    const subscription = accountData.subscription || {};
    const now = Math.floor(Date.now() / 1000);
    const endDateSeconds = subscription?.endDate?.seconds || 0;
    const tokens = Number(subscription?.tokens || 0);
    const isSubscriptionActive = endDateSeconds > now;
    const normalizedPlan = normalizePlanName(subscription?.plan);
    const isLegendaryActive =
      isSubscriptionActive && (normalizedPlan === "الاسطورية" || normalizedPlan === "المتطورة");
    const isDhdActive =
      normalizedPlan === "شراكة مع dhd" &&
      subscription?.dhdPartnershipActive === true;

    if (tokens <= 0 && !isLegendaryActive && !isDhdActive) {
      const error = new Error("INSUFFICIENT_TOKENS");
      error.code = "INSUFFICIENT_TOKENS";
      throw error;
    }

    const nextSubscription = isLegendaryActive || isDhdActive
      ? { ...subscription }
      : {
          ...subscription,
          tokens: Math.max(tokens - 1, 0),
        };

    const nextAccount = {
      id: snapshot.id,
      ...accountData,
      subscription: nextSubscription,
    };

    transaction.update(accountRef, {
      subscription: nextSubscription,
    });

    return nextAccount;
  });
};
